import { render, staticRenderFns } from "./study-contract.vue?vue&type=template&id=13e10619&scoped=true&"
import script from "./study-contract.vue?vue&type=script&lang=js&"
export * from "./study-contract.vue?vue&type=script&lang=js&"
import style0 from "./study-contract.vue?vue&type=style&index=0&id=13e10619&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e10619",
  null
  
)

export default component.exports